import {Howl} from 'howler';
import {musicSprites} from "./musicSprites";
import { currentBackgroundMusicId } from './playBackground';
import {soundSprites} from "./soundSprites";

export let isMuted = false;
export let isTouched = false;

export const music = new Howl({
    src: [
        "assets/sounds/music.ogg",
        "assets/sounds/music.m4a",
        "assets/sounds/music.mp3",
        "assets/sounds/music.ac3"
    ],
    sprite: musicSprites,
    volume: 0,
    autoplay: false,
    mute: true
});

export const sounds = new Howl({
    src: [
        "assets/sounds/sounds.ogg",
        "assets/sounds/sounds.m4a",
        "assets/sounds/sounds.mp3",
        "assets/sounds/sounds.ac3"
    ],
    sprite: soundSprites,
    autoplay: false,
    mute: true
});

export function touch() {
    isTouched = true;
}

export function mute() {
    toggleMute(true);
}

export function unmute() {
    toggleMute(isHidden());
}

function toggleMute(muted: boolean) {
    isMuted = !!muted;
     
    if (muted) {
        if (currentBackgroundMusicId) {
            music.pause(currentBackgroundMusicId);
        }
        
        sounds.playing() && sounds.stop();
    } else {
        if (currentBackgroundMusicId) {
            music.play(currentBackgroundMusicId);
        }
    }
}

function isHidden() {
    const doc = document as any;

    if (typeof doc.hidden !== "undefined") {
        return doc.hidden;
    } else if (typeof doc.msHidden !== "undefined") {
        return doc.msHidden;
    } else if (typeof doc.webkitHidden !== "undefined") {
        return doc.webkitHidden;
    }

    return false;
}

(function (document: any) {
    let visibilityChange;

    if (typeof document.hidden !== "undefined") {
        visibilityChange = "visibilitychange";
    } else if (typeof document.msHidden !== "undefined") {
        visibilityChange = "msvisibilitychange";
    } else if (typeof document.webkitHidden !== "undefined") {
        visibilityChange = "webkitvisibilitychange";
    }

    if (!visibilityChange)
        return;

    document.addEventListener(visibilityChange, () => toggleMute(isHidden()), false);
})(document);